import { apiCall, apiCallAdmin } from "../../services/api-service.js";



export const createCourierApi = async (data) => {
  return await apiCall("POST", `courier`, data);
};

export const getCourierDetailsApi = async (vehicleId) => {
  const response = await apiCall("GET", `courier/get/${vehicleId}`);
  return response.data;
};

export const getLocationFilterApi = async () => {
  const response = await apiCallAdmin("GET", `get_location`);
  return response.data;
};

export const getDepartmentFilterApi = async () => {
  const response = await apiCallAdmin("GET", `get_department`);
  return response.data;
};

export const courierStatusUpdateApi = async (data) => {
  return await apiCall("POST", `courier_statusupdate`, data);
};





